import {connect} from 'react-redux';

import League from '../League.jsx';

function select(state, props) {
    const league = state.application.getIn(['live', 'leagues', props.leagueId]);
    const matches = state.application.getIn(['live', 'matches']);

    return {
        ...props,
        league,
        matches
    };
}

export default connect(select, null, null, false)(League);



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/live/League.jsx